import React, { useState } from 'react';
import { ApiButton, Button, ContentTemplate, Icon, SectionHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import RouteKey from '../../../../routes/key';
import SummaryContent from './SummaryContent';
import { useGetWithdrawalPDF } from '../../../../api/candidate/exam/@coordinator/queries-services/queries';
import { FileUploadState } from '../../../../models/File';
import DownloadProgressModal from '../../../../components/modals/DownloadProgressModal';

const { withdrawal } = RouteKey.child;
const { withdrawal: withdrawalRoute } = RouteKey.withdrawal.child;

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  errorText: {
    color: theme.color.state.stateError,
    marginBottom: theme.spacing(3),
  },
}));

const View = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();
  const theme = useTheme();
  const [shouldOpenPdf, setShouldOpenPdf] = useState(false);
  const [error, setError] = useState('');
  const [fileStatus, setFileStatus] = useState(FileUploadState.IDLE);

  const { refetch: fetchPDF, isFetching: isFetchingPDF, status } = useGetWithdrawalPDF(
    uuid,
    (summaryPDF) => {
      const newWindow = window.open(summaryPDF?.url, '_blank', 'noopener,noreferrer');
      if (newWindow) {
        newWindow.opener = null;
      }

      if (summaryPDF?.url && shouldOpenPdf) {
        window.open(summaryPDF?.url, '_blank');
        setShouldOpenPdf(false);
      }
    },
    (_) => {
      setFileStatus(FileUploadState.FAILED);
    }
  );

  const additionalComponentRenderer = () => {
    if (isFetchingPDF) {
      return (
        <Icon name={IconName.loadingIndicator} size="L" color={theme.color.link.linkActive02} />
      );
    }
    return (
      <ApiButton
        variant="text"
        color="primary"
        status={status}
        onClick={() => fetchPDF()}
        size="small"
        id="link-download"
      >
        <IconWithLabel
          iconName={IconName.download}
          iconSize="M"
          label={t('withdrawal->>ViewApplication.DownloadSummary')}
          typographyProps={{
            variant: 'h5',
          }}
        />
      </ApiButton>
    );
  };

  const sectionHeader = (
    <SectionHeader
      title={t('withdrawal->>Coordinator.Summary.View.SectionHeader')}
    >
      {additionalComponentRenderer()}
    </SectionHeader>
  );

  const handleCloseDownloadErrorPrompt = () => {
    setFileStatus(FileUploadState.IDLE);
  };

  return (
    <>
      <SummaryContent uuid={uuid} sectionHeader={sectionHeader} setError={setError} isView />
      <ContentTemplate type="large" continuous>
        {error && (
          <Typography className={classes.errorText} variant="body2">
            {error}
          </Typography>
        )}
        <Button
          variant="outlined"
          onClick={() => history.push(`/${withdrawal}/${withdrawalRoute.route}`)}
        >
          {t('withdrawal->>Coordinator.Summary.View.BackToApplication')}
        </Button>
      </ContentTemplate>
      {fileStatus === FileUploadState.FAILED && (
        <DownloadProgressModal
          modalState
          fileDownloadStatus={FileUploadState.FAILED}
          onDialogClose={handleCloseDownloadErrorPrompt}
        />
      )}
    </>
  );
};

export default View;
